var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#436ECA",
    cx: 22,
    cy: 22,
    r: 22
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.738 11.945l-2.794-.004c-3.138 0-5.166 1.875-5.166 4.777v2.203h-2.81c-.242 0-.439.177-.439.396v3.191c0 .22.197.396.44.396h2.809v8.053c0 .219.196.396.439.396h3.665c.242 0 .439-.177.439-.396v-8.053h3.284c.243 0 .44-.177.44-.396v-3.19a.378.378 0 00-.128-.28.465.465 0 00-.31-.117H23.32v-1.867c0-.898.237-1.353 1.535-1.353h1.881c.243 0 .44-.178.44-.397v-2.963c0-.218-.197-.395-.44-.396z",
    fill: "#FFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIcon);
export default __webpack_public_path__ + "static/media/facebookIcon.f47660472e5f144ea91c9a86d213669e.svg";
export { ForwardRef as ReactComponent };